// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"413":"d1ea83d6","566":"9794c080"}[chunkId] + ".chunk.js";
};